import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { Shield, AlertCircle, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AdminLoginPage = () => {
  const { isAuthenticated, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-[#0A1128] flex items-center justify-center text-white/50 text-sm"
        dir="rtl"
      >
        جارٍ التحقّق من الجلسة...
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/admin/suggestions" replace />;
  }

  // رسالة "غير مصرح" تأتي بعد callback إذا رُفض الإيميل
  const denied =
    new URLSearchParams(location.search).get("denied") === "1";

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/auth-callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div
      className="min-h-screen bg-[#0A1128] text-white flex items-center justify-center p-4"
      dir="rtl"
    >
      <div className="w-full max-w-md rounded-3xl bg-gradient-to-br from-white/[0.05] to-white/[0.01] border border-[#C9A96A]/20 backdrop-blur-xl shadow-2xl shadow-blue-900/20 overflow-hidden">
        <div className="px-6 sm:px-8 pt-8 pb-6 text-center border-b border-white/5">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-b from-[#D4B278] to-[#B08A4A] text-[#0A1128] flex items-center justify-center mx-auto mb-3 shadow-lg">
            <Shield className="w-6 h-6" />
          </div>
          <h1 className="text-white text-xl sm:text-2xl font-black">
            لوحة تحكم الإدارة
          </h1>
          <p className="text-white/50 text-xs mt-1.5">
            الدخول محصور لطاقم Rush Store فقط.
          </p>
        </div>

        <div className="p-6 sm:p-8 space-y-4">
          {denied && (
            <div
              data-testid="admin-login-denied"
              className="flex items-start gap-2 rounded-xl bg-red-500/10 border border-red-500/30 p-3 text-red-200 text-xs"
            >
              <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
              <span>
                <strong>غير مصرح لك بالدخول.</strong> إيميل حساب Google الذي
                استخدمته غير موجود في قائمة المسؤولين.
              </span>
            </div>
          )}

          <p className="text-white/60 text-xs text-center leading-6">
            استخدم حساب Google المصرَّح له بإدارة Rush Store.
          </p>

          <button
            type="button"
            data-testid="admin-google-login"
            onClick={handleGoogleLogin}
            className="w-full inline-flex items-center justify-center gap-3 h-12 rounded-xl bg-white hover:bg-white/90 text-[#0A1128] font-black text-sm transition"
          >
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path
                fill="#FFC107"
                d="M43.6 20.5H42V20H24v8h11.3C33.9 32.1 29.4 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.6 6.9 29 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.3-.4-3.5z"
              />
              <path
                fill="#FF3D00"
                d="M6.3 14.7l6.6 4.8C14.7 15.2 19 12 24 12c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.6 6.9 29 5 24 5 16.3 5 9.6 9 6.3 14.7z"
              />
              <path
                fill="#4CAF50"
                d="M24 43c5 0 9.5-1.9 12.9-5l-6-4.9C29.1 34.5 26.7 35 24 35c-5.4 0-9.9-3.4-11.6-8.1l-6.6 5C9.1 38.9 15.9 43 24 43z"
              />
              <path
                fill="#1976D2"
                d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5v.1l6 4.9C36.6 41.8 43 36 43 24c0-1.2-.1-2.3-.4-3.5z"
              />
            </svg>
            <span>تسجيل الدخول باستخدام Google</span>
          </button>

          <p className="text-white/30 text-[10px] text-center mt-3 leading-5">
            بعد تسجيل الدخول، يتم التحقق من إيميلك مقابل قائمة المسؤولين
            المصرَّح لهم.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
